import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DetailInfo } from 'common/model';
import { isDerivedReadOnlyField } from 'shared/shared.helper';

@Component({
    selector: 'app-detail-info-list',
    templateUrl: './detail-info-list.component.html',
    standalone: false
})

export class DetailInfoListComponent {

  @Input() detailInfoList: DetailInfo[] = [];
  @Input() formGroup!: FormGroup;

  // Derived fields have no form control (see the helper), so the editable list skips them.
  public isDerivedReadOnlyField = isDerivedReadOnlyField;

}
